// GENERATED by scripts/build_icons.mjs from react-icons 5.7.0: do not edit by hand.
import { GenIcon } from 'react-icons/lib'

export function FiShare (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"path","attr":{"d":"M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"},"child":[]},{"tag":"polyline","attr":{"points":"16 6 12 2 8 6"},"child":[]},{"tag":"line","attr":{"x1":"12","y1":"2","x2":"12","y2":"15"},"child":[]}]})(props);
};
